class Zello {
  static get IsLoggedIn() {
    return Zello.isLoggedIn;
  }

  static set IsLoggedIn(value) {
    Zello.isLoggedIn = value;
  }

  static get VerifyLogin() {
    return Zello.verifyLogin;
  }

  static set VerifyLogin(value) {
    Zello.verifyLogin = value;
  }

  static set Profile(profile) {
    Zello.profile = profile;
  }

  static get Profile() {
    return Zello.profile;
  }

  static get HasProfile() {
    return Zello.profile !== undefined;
  }

  static getApiUrl(path) {
    const isRemote = process.env.REACT_APP_BACKEND_REMOTE;
    return (isRemote ? "https://beta-developers.zello.com/api" : "/api") + path;
  }

  static formatDate(ts) {
    let date = new Date(ts * 1000);
    return date.toLocaleDateString([], { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })
      + " " + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  }

  static setProfile(profile) {
    Zello.isLoggedIn = profile.isLoggedIn;
    Zello.verifyLogin = profile.verify;

    if (profile.profile) {
      Zello.profile = profile.profile;
    } else {
      Zello.profile = undefined;
    }
  }

  static logout() {
    Zello.profile = undefined;
    Zello.isLoggedIn = false;
    Zello.verifyLogin = false;
  }
}

export default Zello;


// WEBPACK FOOTER //
// ./src/Zello.js